(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eos-bracelet-story-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eos-bracelet-story-options')) {
    customElements.define('eos-bracelet-story-options', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const story = this.querySelector('[data-eos-story]');
        const details = this.querySelector('[data-eos-details]');
        if (!story || !details) return;
        this.ready = true;
        const marker = Array.from(story.querySelectorAll('p, h2, h3, h4, h5, h6, li, div')).find(element =>
          /^gift\s+ideas\s*:/i.test(element.textContent.trim()) &&
          !Array.from(element.children).some(child => /^(P|H[2-6]|LI|DIV)$/.test(child.tagName))
        );
        if (!marker) return;
        const range = document.createRange();
        range.setStartBefore(marker);
        range.setEnd(story, story.childNodes.length);
        details.append(range.extractContents());
        details.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eos-charm-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eos-charm-selector')) {
    customElements.define('eos-charm-selector', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.closest('form');
        this.select = this.querySelector('[data-eos-charm-choice]');
        this.variants = JSON.parse(this.querySelector('[data-eos-product-variants]').textContent);
        this.optionNames = JSON.parse(this.querySelector('[data-eos-product-options]').textContent);
        this.charmIndex = this.optionNames.findIndex(name => name.toLowerCase().includes('charm'));
        this.select.disabled = false;
        const initial = this.variants.find(v => String(v.id) === this.dataset.selectedId);
        if (this.charmIndex >= 0 && initial) {
          const oldChoice = initial.options[this.charmIndex].toLowerCase();
          const title = oldChoice.includes('gold') ? 'Angel wing (Gold)' : oldChoice.includes('silver') ? 'Angel wing (Silver)' : '';
          const choice = Array.from(this.select.options).find(o => o.dataset.title === title);
          if (choice) this.select.value = choice.value;
          const variantPicker = this.closest('section')?.querySelector('variant-radios, variant-selects');
          const components = variantPicker ? [customElements.whenDefined(variantPicker.localName)] : [];
          if (this.closest('section')?.querySelector('pickup-availability')) components.push(customElements.whenDefined('pickup-availability'));
          if (this.closest('section')?.querySelector('media-gallery')) components.push(customElements.whenDefined('media-gallery'));
          Promise.all(components).then(() => {
            const picker = this.closest('section')?.querySelector('variant-radios, variant-selects');
            const original = picker?.querySelector('[data-eos-original-charm]');
            if (original && initial.options[this.charmIndex] !== original.value) original.dispatchEvent(new Event('change', {bubbles: true}));
          });
        }
        this.onChange = () => this.updateTotal();
        this.select.addEventListener('change', this.onChange);
        this.variantInput = this.form.querySelector('[name="id"]');
        this.variantInput.addEventListener('change', this.onChange);
        this.updateTotal();
      }
      disconnectedCallback() {
        this.select?.removeEventListener('change', this.onChange);
        this.variantInput?.removeEventListener('change', this.onChange);
        this.ready = false;
      }
      baseVariant(id) {
        const variant = this.variants.find(v => String(v.id) === String(id));
        if (!variant || this.charmIndex < 0) return variant;
        return this.variants.find(v => v.options.every((value, index) => index === this.charmIndex ? /without|no charm/i.test(value) : value === variant.options[index]));
      }
      updateTotal() {
        const output = this.querySelector('[data-eos-charm-total]');
        const base = this.baseVariant(this.form.querySelector('[name="id"]').value);
        const option = this.select.selectedOptions[0];
        output.hidden = !option?.value || !base;
        if (!output.hidden) {
          const price = (base.price + Number(option.dataset.price)) / 100;
          output.textContent = this.dataset.totalLabel + ' ' + new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency}).format(price);
        }
      }
      prepare(data) {
        const base = this.baseVariant(data.get('id'));
        if (!base) throw new Error(this.dataset.sizeError);
        data.set('id', base.id);
        if (!this.select.value) return data;
        const quantity = Number(data.get('quantity') || 1);
        const group = crypto.randomUUID();
        const result = new FormData();
        result.set('items[0][id]', base.id);
        result.set('items[0][quantity]', quantity);
        for (const [key,value] of data.entries()) {
          if (key.startsWith('properties[')) result.append('items[0][' + key.replace('properties[','properties]['), value);
          if (key === 'selling_plan' && value) result.set('items[0][selling_plan]',value);
        }
        result.set('items[0][properties][_eos_charm_group]', group);
        result.set('items[1][id]', this.select.value);
        result.set('items[1][quantity]', quantity);
        result.set('items[1][parent_id]', base.id);
        result.set('items[1][properties][_eos_charm_group]', group);
        result.set('items[1][properties][_eos_charm_child]', 'true');
        const size = base.options.filter((value,index) => index !== this.charmIndex && value !== 'Default Title').join(' / ');
        result.set('items[1][properties][For bracelet]', this.dataset.productTitle + (size ? ' — ' + size : ''));
        return result;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eos-holiday-polish"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eos-holiday-polish')) {
  customElements.define('eos-holiday-polish', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.enhance = () => {
        if (!this.isConnected) return;
        document.querySelectorAll('.eosc').forEach(root => {
          root.querySelectorAll('.eosc-spread').forEach(spread => {
            const host = spread.querySelector('.eosc-spread__products');
            if (!host || host.querySelector('.eosc-collection-links')) return;
            const source = Array.from(this.querySelectorAll('[data-eos-chapter]')).find(t => spread.classList.contains(`eosc-spread--${t.dataset.eosChapter}`));
            if (source?.content.querySelector('a')) {
              const fragment = source.content.cloneNode(true);
              const navigation = fragment.querySelector('.eosc-collection-links');
              const headingId = spread.getAttribute('aria-labelledby');
              const caption = navigation?.querySelector('p');
              if (headingId && caption) {
                caption.id = `${headingId}-collections`;
                navigation.setAttribute('aria-labelledby', `${headingId} ${caption.id}`);
                navigation.removeAttribute('aria-label');
              }
              host.append(fragment);
            }
          });
          root.querySelectorAll('.eosc-tile__letter').forEach(letter => {
            if (letter.textContent.trim() !== 'O' || letter.hasAttribute('data-eos-wreath-ready')) return;
            const wreath = this.querySelector('[data-eos-wreath]');
            if (wreath) {letter.append(wreath.content.cloneNode(true));letter.setAttribute('data-eos-wreath-ready','');}
          });
        });
        try {
          const saved = JSON.parse(sessionStorage.getItem('eos-giftbook-return') || 'null');
          if (saved && Date.now() - saved.time < 43200000) {
            const url = new URL(saved.href,location.origin);
            const base = new URL(this.dataset.guideUrl,location.origin);
            if (url.origin === location.origin && url.pathname === base.pathname && url.searchParams.get('view') === base.searchParams.get('view')) {
              document.querySelectorAll('[data-eos-giftbook-return]').forEach(a => {a.href=url.pathname+url.search+url.hash;});
            }
          }
        } catch (_) {}
      };
      document.addEventListener('click',event => {
        const link=event.target.closest?.('a[href]');
        if (link) {
          const spread=link.closest('.eosc-spread');
          if (spread && spread.id && !link.getAttribute('href').startsWith('#')) {
            try {
              const destination=new URL(link.href,location.origin);
              const url=new URL(this.dataset.guideUrl,location.origin);
              if (destination.origin === location.origin && url.origin === location.origin) {
                url.hash=spread.id;
                sessionStorage.setItem('eos-giftbook-return',JSON.stringify({href:url.pathname+url.search+url.hash,time:Date.now()}));
              }
            } catch (_) {}
          }
        }
        document.querySelectorAll('.eosh-holiday-nav details[open],.eos-collection-switcher[open]').forEach(details => {
          if (!details.contains(event.target) || link && details.contains(link)) details.open=false;
        });
      },opts);
      document.addEventListener('keydown',event => {
        if(event.key !== 'Escape') return;
        document.querySelectorAll('.eosh-holiday-nav details[open],.eos-collection-switcher[open]').forEach(details => {
          const focused=details.contains(document.activeElement);
          details.open=false;
          if(focused) details.querySelector('summary')?.focus();
        });
      },opts);
      document.addEventListener('shopify:section:load',this.enhance,opts);
      window.addEventListener('pageshow',this.enhance,opts);
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.enhance,{...opts,once:true});
      else this.enhance();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
